var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1738 13.5898C13.5458 13.5898 15.4687 11.6669 15.4687 9.29491C15.4687 6.9229 13.5458 5 11.1738 5C8.8018 5 6.87891 6.9229 6.87891 9.29491C6.87891 11.6669 8.8018 13.5898 11.1738 13.5898Z",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26459 13.903C3.85898 15.2305 3 17.0266 3 19.0048V25.1739H19.3207L19.3467 19.0048C19.3467 17.0786 18.5398 15.3346 17.1862 14.0071C17.1342 13.955 17.1081 13.929 17.0561 13.877",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1844 11.0582C23.8573 11.0582 25.2135 9.70203 25.2135 8.0291C25.2135 6.35617 23.8573 5 22.1844 5C20.5114 5 19.1553 6.35617 19.1553 8.0291C19.1553 9.70203 20.5114 11.0582 22.1844 11.0582Z",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1699 20.957H27.9746L28.0006 16.2196C28.0006 14.7359 27.3759 13.3823 26.3347 12.3672",
    stroke: "#919EAB",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.d261674dd510026cc898d0205bd0c560.svg";
export { ForwardRef as ReactComponent };